import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

export class UIOptionSelectEvent {
  target: HTMLElement;
  index: number;
  value: any;
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ui-select-option',
  templateUrl: 'ui-select-option.component.html'
})
export class UISelectOptionComponent implements AfterViewInit {
  @ViewChild('option') option: ElementRef<HTMLDivElement>;
  @Input() group: string;
  @Input() value: unknown;
  @Output() onSelect: EventEmitter<UIOptionSelectEvent> = new EventEmitter();
  @Input() selected = false;
  isNavigated = false;

  constructor(
    public host: ElementRef<HTMLDivElement>
  ) {}

  ngAfterViewInit(): void {
    this.host.nativeElement.classList.add('≈flex', '≈flex-row-reverse', '≈flex-nowrap', '≈items-center');
    if (this.group) {
      this.host.nativeElement.setAttribute('data-group', this.group);
    }
    this.host.nativeElement.setAttribute('data-value', this.value as any);
  }

  /* Being controlled by its UI-ACTION-LIST parent */
  select(event: MouseEvent): void {

  }
}

